const COOKIE_CONSENT_KEY = 'cookie_consent';
const COOKIE_SETTINGS_KEY = 'cookie_settings';

export const getCookieConsent = () => {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  const settings = localStorage.getItem(COOKIE_SETTINGS_KEY);
  
  return {
    hasConsent: consent === 'true',
    settings: settings ? JSON.parse(settings) : null
  };
};

export const hasConsentFor = (type) => {
  const { settings } = getCookieConsent();
  if (!settings) return false;
  
  // Essential cookies are always allowed
  if (type === 'essential') return true;
  
  return settings[type] === true;
};

export const loadScript = (src, type) => {
  return new Promise((resolve, reject) => {
    if (!hasConsentFor(type)) {
      reject(new Error(`No consent for ${type} cookies`));
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('data-cookie-type', type);
    
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    
    document.body.appendChild(script);
  });
};

export const loadScripts = async (scripts) => {
  const results = [];
  
  for (const { src, type } of scripts) {
    try {
      const script = await loadScript(src, type);
      results.push({ src, type, success: true });
    } catch (error) {
      console.warn(`Failed to load script ${src}:`, error);
      results.push({ src, type, success: false, error });
    }
  }
  
  return results;
};

// Example usage:
// const scripts = [
//   { src: 'https://analytics.example.com/script.js', type: 'analytics' },
//   { src: 'https://marketing.example.com/script.js', type: 'marketing' }
// ];
// loadScripts(scripts).then(results => console.log('Scripts loaded:', results)); 